import React from 'react';
import { volumes } from '../data/volumes';
import { SectionLabel } from './ui/SectionLabel';
export function LibrarySection() {
  return <section className="w-full bg-cream py-10 sm:py-14 lg:py-20" aria-labelledby="library-heading" data-id="element-105" data-mp="23cai30lpl8x6">
      <div className="mx-auto w-full max-w-content px-5 sm:px-8" data-id="element-106" data-mp="2hbs8tlikew96">
        <div className="mx-auto max-w-2xl text-center" data-id="element-107" data-mp="2daq44p5vprzt">
          <div className="flex justify-center" data-id="element-108" data-mp="2d95endyf8z8t">
            <SectionLabel data-id="element-109" data-mp="1pmgpq8azw6ip">The library</SectionLabel>
          </div>
          <h2 id="library-heading" className="mt-3 font-serif text-[1.6rem] font-semibold uppercase leading-[1.08] text-ink sm:text-4xl" data-id="element-110" data-mp="1kmknadhy4n59">
            120 Ready-to-Teach classes.
            <span className="block text-forest" data-id="element-111" data-mp="1tmh7a1te4xtz">6 professional volumes.</span>
          </h2>
        </div>

        <ul className="mt-6 grid gap-2.5 sm:grid-cols-2 sm:gap-3" data-id="element-112" data-mp="15wmrbbdryt5i">
          {volumes.map(volume => <li key={volume.number} className="flex h-full items-center gap-3.5 rounded-2xl border border-sandDark bg-ivory p-3 sm:gap-4 sm:p-4" data-id="element-113" data-mp="11urtwhyyszx0">
              <img src={volume.cover} alt={`Volume ${volume.number}: ${volume.title}`} className="w-16 shrink-0 rounded-md sm:w-20" width={900} height={1200} loading="lazy" data-id="element-114" data-mp="12f67c1st6c1x" />
              <div className="min-w-0" data-id="element-115" data-mp="ei8x6eetmegu">
                <div className="flex flex-wrap items-center gap-x-2 gap-y-0.5" data-id="element-116" data-mp="ejjy86gvt849">
                  <p className="text-[0.55rem] font-semibold uppercase tracking-label text-gold" data-id="element-117" data-mp="ji4zm97vdxua">
                    Volume {volume.number}
                  </p>
                  <span className="text-sandDark" aria-hidden="true" data-id="element-118" data-mp="tf9oigt3o7es">
                    ·
                  </span>
                  <p className="text-[0.55rem] font-semibold uppercase tracking-label text-forest" data-id="element-119" data-mp="1zvv6touad285">
                    {volume.classes}
                  </p>
                </div>
                <h3 className="mt-1 font-serif text-[0.88rem] font-semibold uppercase leading-tight text-ink sm:text-base" data-id="element-120" data-mp="4s6uptz4r7ah">
                  {volume.title}
                </h3>
                <p className="mt-1.5 text-[0.76rem] leading-snug text-muted sm:text-[0.85rem]" data-id="element-121" data-mp="3w0kowj0lahar">
                  {volume.description}
                </p>
              </div>
            </li>)}
        </ul>

        <p className="mt-5 flex flex-wrap items-center justify-center gap-x-2 gap-y-1 rounded-full border border-gold/30 bg-ivory px-5 py-3 text-center text-[0.62rem] font-semibold uppercase tracking-label text-muted sm:text-xs" data-id="element-122" data-mp="3i73650fq98ls">
          <span data-id="element-123" data-mp="3qzn92d31xzcf">6 Volumes</span>
          <span className="text-gold" aria-hidden="true" data-id="element-124" data-mp="3r0yc2aoob32h">
            ×
          </span>
          <span data-id="element-125" data-mp="3m7viw3nt5vmt">20 Classes</span>
          <span className="text-gold" aria-hidden="true" data-id="element-126" data-mp="3m6u4pqbhwt0v">
            =
          </span>
          <span className="text-forest" data-id="element-127" data-mp="2ygzt1c2wxai7">120 Ready-to-Teach Classes</span>
        </p>
      </div>
    </section>;
}